export const INVENTORY_TYPE = [
  { key: 'A Category', value: 'a', label: 'A Category' },
  { key: 'B Category', value: 'b', label: 'B Category' },
  { key: 'C Category', value: 'c', label: 'C Category' },
];

export const INVENTORY_HISTORY_METHOD = [
  { key: 'Replace', value: 'force_update', label: 'Replace' },
  { key: 'Add', value: 'increase', label: 'Add' },
  { key: 'Remove', value: 'decrease', label: 'Remove' },
  { key: 'Create', value: 'create', label: 'Create' },
  { key: 'Allocate', value: 'allocate', label: 'Allocate' },
  { key: 'Consume', value: 'consume', label: 'Consume' },
  { key: 'Deallocate', value: 'deallocate', label: 'Deallocate' },
];

export const INVENTORY_CONTEXT = [
  { key: 'Undefined', value: 'undefined', label: 'Undefined' },
  { key: 'New Order', value: 'new_order', label: 'New Order' },
  { key: 'Order Cancel', value: 'order_cancel', label: 'Order Cancel' },
  {
    key: 'Order Reject Not Found',
    value: 'order_reject_not_found',
    label: 'Order Reject Not Found',
  },
  {
    key: 'Order Reject Damaged',
    value: 'order_reject_damaged',
    label: 'Order Reject Damaged',
  },
  { key: 'Order Transfer', value: 'order_transfer', label: 'Order Transfer' },
  { key: 'Manifest Close', value: 'manifest_close', label: 'Manifest Close' },
  {
    key: 'Return Manifest Close',
    value: 'return_manifest_close',
    label: 'Return Manifest Close',
  },
  {
    key: 'Gate Pass Item Create',
    value: 'gate_pass_item_create',
    label: 'Gate Pass Item Create',
  },
  {
    key: 'Gate Pass Submit',
    value: 'gate_pass_submit',
    label: 'Gate Pass Submit',
  },
  {
    key: 'Gate Pass Item Delete',
    value: 'gate_pass_item_delete',
    label: 'Gate Pass Item Delete',
  },
  {
    key: 'Bulk Inventory Adjustment',
    value: 'bulk_inventory_adjustment',
    label: 'Bulk Inventory Adjustment',
  },
  {
    key: 'Inventory Adjustment',
    value: 'inventory_adjustment',
    label: 'Inventory Adjustment',
  },
];
